export const STRIPE_PUB_KEY = (() =>
  window.location.host.split('.').length === 2
    ? 'pk_live_WWjRl1ZV69yg3NtoXpiUwAcX00OEgbemcF'
    : 'pk_test_SSx2CQPtmJQMD9N8XKbbg80V00ibxnnhvM')();
